module.exports = __webpack_public_path__ + "img/iips.logo.e42277ff.jpeg";